<template>
  <div
    class="tw-bg-purple-50 tw-min-h-screen d-flex flex-column justify-tstart space-top"
  >
    <v-img
      :lazy-src="image"
      height="200px"
      width="200px"
      contain
      :src="image"
      class="my-0 mx-auto flex-grow-0"
    />
    <div class="--container d-flex justify-center">
      <div class="pt-3 pb-6">
        <p class="text m-0 text-center">
          <span> {{ text }} </span>
        </p>
      </div>
    </div>
    <v-progress-linear
      color="primary"
      buffer-value="100"
      :value="progress"
      height="36"
      backgroundColor="#D4D5D8"
      class="progress"
    >
      <template v-slot:default="{ value }"> {{ Math.ceil(value) }}% </template>
    </v-progress-linear>
  </div>
</template>

<script>
import consola from 'consola';

const EMPTY_STATE_IMAGE = require('@/assets/img/empty-review.png');

export default {
  props: {
    progress: Number,
    is_calibration: Boolean,
  },

  computed: {
    image() {
      return EMPTY_STATE_IMAGE;
    },

    text() {
      if (this.is_calibration) {
        consola.info('In progres state and calibration is true');
        return 'We are going to present an initial set of ten candidates. Based on your feedback, we will calibrate our search and then present your full batch for today.';
      }
      consola.info('In progres state and calibration is false');
      return 'We have finished calibration. Based on your feedback, we are finding you an improved set of candidates.';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/variables.scss';

.space-top {
  padding-top: 70px;
}

.placeholder {
  color: #aaa;
  font-size: 1.5rem;
  padding: 2.5rem;
}
.progress {
  max-width: 386px;
  border-radius: 0;
}

.--container {
  max-width: 500px;
}

.text {
  font-size: 18px;
  font-weight: 700;
  line-height: 1.556;
  letter-spacing: 0.5px;
  color: #a1a5a6;
}
</style>
